import { RootState } from "interfaces/generics.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { Dispatch } from "redux";
import { IGetAllVehiclesAction, ISelectVehicleAction } from "../interfaces/garage.interface";
import { waitForGarageAndAddVehicle } from "./waitForGarageAndAddVehicle";

// selectionType can be MANUAL or AUTOMATIC

export function addVehicle(vehicle: any, force = false) {
  return (dispatch: Dispatch<ISelectVehicleAction | IGetAllVehiclesAction, RootState>, getState: any) => {
    if (!vehicle) {
      return;
    }
    // CAUTION: Destructure vehicle. It may contain additional keys which can result in 4xx errors in API.
    // Always add properties to save in the variable "vehicleToset"
    const {
      year, make, model, fitmentOptions,
    } = vehicle;
    if (year && make && model) {
      const vehicleToset: IVehicle = {
        year,
        make,
        model,
        fitmentOptions: fitmentOptions || [],
      };
      const { isLoading } = getState().garage;
      // we can't add vehicle until garage is loaded,
      // as garage and current vehicle can have different vehicle engine.
      if (!isLoading) {
        dispatch(waitForGarageAndAddVehicle(vehicleToset, force));
      } else {
        const interval = setInterval(() => {
          const { isLoading: newIsLoading } = getState().garage;
          if (!newIsLoading) {
            clearInterval(interval);
            dispatch(waitForGarageAndAddVehicle(vehicleToset, force));
          }
        }, 200);
      }
    }
  };
}
